var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"13.9rem"},attrs:{"id":"bor"}},[_c('div',{staticClass:"lineChart Chart",attrs:{"id":_vm.useData.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }